import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import Swal from 'sweetalert2';
import { ExternalAuthService } from './_infrastructure/services/auth/external-auth/external-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'transparencia-educacao';

  vLibrasScriptElement!: HTMLScriptElement;
  constructor(
    private externalAuthService: ExternalAuthService,
    private elRef: ElementRef,
    private renderer: Renderer2) {
  }
  showBotaoTopo = false;

  ngOnInit() {
    this.blockWhileLoadingPortal();
  }

  ngAfterViewInit() {
    this.loadVLibras();
  }

  private async blockWhileLoadingPortal() {
    if (!this.externalAuthService.shouldBlockStartup()) {
      return;
    }

    Swal.fire({
      title: 'Carregando portal...',
      text: 'Aguarde enquanto os dados iniciais sao preparados.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      await this.externalAuthService.loadToken();
    } finally {
      if (Swal.isLoading()) {
        Swal.close();
      }
    }
  }

  private loadVLibras() {
    this.vLibrasScriptElement = document.createElement("script");
    this.vLibrasScriptElement.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
    this.vLibrasScriptElement.async = true;
    this.vLibrasScriptElement.onload = () => this.initializeVLibras();
    document.body.appendChild(this.vLibrasScriptElement);
  }

  private initializeVLibras() {
    this.vLibras();
  }

  private vLibras(): void {
    new (window as any).VLibras.Widget('https://vlibras.gov.br/app');
  }
} 
